// Interview Surveys *************************************************************************
// pathname: /v1/interview/surveys
// ************************************************************************************************
import { ApiGetInterviewSurveysOk, useSwrApi } from 'src/hooks/useSwrApi';


/**
 * @description SWR: fetch interview surveys
 * @param locale
 */
export const useSwrInterviewSurveys = (locale: string) => {
  // SWR: fetch data
  const {
    data, error, isLoading, isValidating, mutate,
  } = useSwrApi<ApiGetInterviewSurveysOk>({
    url: '/v1/interview/surveys',
    locale,
    apiOptions: {
      revalidateOnFocus: false,
      dedupingInterval: 10000, // 10 seconds - surveys list response can be changed due to user replying to a question
    },
  });

  // Return data
  return {
    data: data !== undefined ? data : [],
    error,
    mutate,
    isLoading,
    isValidating,
  };
};
